<template>
    <div id="principal">
        <top-bar ref="topbar"></top-bar>
            <br>
            <div id="login-principal" class="login-principal">
                <center v-if="exibeTitulo"><b>Informe seus dados:</b><br/><br/></center>
                <form-login  :telainicio="true"  @ajustaposicaoteclado="ajustaposicaoteclado" />
            </div>
        
        <load-mask />
    </div>
</template>

<script>

import TopBar from '@/components/layout/TopBar.vue';
import FormLogin from '@/components/layout/FormLogin.vue';
import LoadMask from '@/views/LoadMask.vue';

export default {
    name: "login",
    components: {
        TopBar,
        FormLogin,
        LoadMask
    },
    created: function(){
        if(window.MobileAccessibility){
            window.MobileAccessibility.setTextZoom(100);
        }
    },

    beforeCreate: function(){
        if(window.MobileAccessibility){
            window.MobileAccessibility.setTextZoom(100);
        }
    },

    mounted: function(){
        if(window.MobileAccessibility){
            window.MobileAccessibility.setTextZoom(100);
        }

        this.$root.setSessao('');

    },
    data() {
        return {
            exibeTitulo: true
        };        
    },

    methods:{
        ajustaposicaoteclado(campo){
            if (campo=='login'){
                document.getElementById('login-principal').style.top = '20px'; 
                this.exibeTitulo = false;
            } else  if (campo=='senha'){
                document.getElementById('login-principal').style.top = '20px'; 
                this.exibeTitulo = false;
            } else {
                document.getElementById('login-principal').style.top = '130px';
                this.exibeTitulo = true;
            }
        }

    }

    
};

</script>

<style>


.login-principal{
    left: 45px;
    right: 45px;
    top: 130px;
    position: fixed;
    z-index: 3;
    background: white;
    border-radius: 10px;
    padding-top: 30px;
    padding-bottom: 30px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 6px 0 rgba(0, 0, 0, 0.19);
    transition: all  0.2s ease-in-out;	
}

.vdatetime-input{
    width: 0px !important;
    height: 0px !important;
    border: 0px solid;
}


</style>